import type { IValidationField } from '../types';
import * as yup from 'yup';

export default function requiredNumber({ label = '' }: IValidationField) {
  return yup.number().required().label(label);
}
